export default "__VITE_ASSET__B5d8pwnu__"